import $ from 'jquery';

const TARGET_ITEM_CLASS = 'list-accordion__item';
const TARGET_ACTIVE_CLASS = TARGET_ITEM_CLASS + '--active';

$(() => {
    let $accordion = $('.list-accordion');

    if ($accordion.length) {
        $accordion.on('click', `.${TARGET_ITEM_CLASS}__header .toggle`, function() {
            let $trigger = $(this);
            let $item = $trigger.parents(`.${TARGET_ITEM_CLASS}`);

            if ($item.hasClass(TARGET_ACTIVE_CLASS)) {
                $trigger.find('.icon').text('▼');
                $item.removeClass(TARGET_ACTIVE_CLASS).find(`.${TARGET_ITEM_CLASS}__content`).stop().slideUp();
            } else {
                $trigger.find('.icon').text('▲');
                $item.addClass(TARGET_ACTIVE_CLASS).find(`.${TARGET_ITEM_CLASS}__content`).stop().slideDown();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/components/Accordion.ts